const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Rosella Rise"

  //   webfeedDebuggerWebsiteUrl:
  //     "https://www.avjennings.com.au/communities/nsw/rosella-rise-warnervale-2259/masterplan",
  //   webfeedConfig: {
  //     mode: "masterplan", // masterplan, feed
  //     type: "land" // land, packages, dwellings etc
  //   }
  // add other conf items below if needed
};
